module.exports = __webpack_public_path__ + "static/img/2-5.34a65872.png";